import { createI18n } from 'vue-i18n'
import pl from './pl.js'
import en from './en.js'

function initialLocale() {
  try {
    const saved = localStorage.getItem('addcrm:locale')
    if (saved === 'pl' || saved === 'en') return saved
  } catch {
    // storage may be unavailable; the language then follows the browser
  }
  return (navigator.language || 'pl').toLowerCase().startsWith('en') ? 'en' : 'pl'
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: initialLocale(),
  fallbackLocale: 'pl',
  messages: { pl, en },
  missingWarn: false,
  fallbackWarn: false,
})

export function setLocale(locale) {
  const value = locale === 'en' ? 'en' : 'pl'
  i18n.global.locale.value = value
  document.documentElement.lang = value
  try {
    localStorage.setItem('addcrm:locale', value)
  } catch {
    // not remembered across reloads; harmless
  }
}

export const t = (...args) => i18n.global.t(...args)
export const te = (...args) => i18n.global.te(...args)

export default i18n
